import { debounce } from '@/src/utils';
import { HomePageLoganType, logan } from '@/src/common/utils/Logan';
import { Polling, PollingCallback } from './Poling';
import { nuclearRefreshRequest } from '../request/api';

const EventCenter = Mach.requireModule('EventCenter');

export enum NuclearStatus {
  CLOSED = 0,
  OPEN = 1,
}

/**
 * 用于处理核按钮轮询逻辑
 */
export class PollingManager {
  private static instance: Polling | null = null;
  private static pollingCallback: PollingCallback = async () => {
    await this.nuclearPollingCall();
  };
  private constructor() { }

  static createInstance(): Polling {
    if (this.instance === null) {
      const interval = getHornConfig();
      this.instance = new Polling(PollingManager.pollingCallback, interval);
    }
    return this.instance;
  }

  static getInstance(): Polling | null {
    return this.instance;
  }

  static destroyInstance(): void {
    if (this.instance !== null) {
      this.instance.destroy();
      this.instance = null;
    }
  }

  static forceRefreshIfRunning(): void {
    if (this.instance?.isRunning() && globalThis.isNuclearButtonOn) {
      //根据核按钮状态进行刷新
      this.nuclearPollingCall();
    }
  }

  //添加防抖
  static nuclearPollingCall = debounce(() => {
    logan(HomePageLoganType.PreHeat, {
      msg: 'nuclearPollingCall',
      count: this.instance?.getPolingCount()
    });
    nuclearRefreshRequest().then((res: any) => {
      if (res.data.nuclearStatus === NuclearStatus.CLOSED) {
        // 记录日志
        // 核按钮关闭，触发首页刷新，停止轮询
        EventCenter?.emit('refresh_all_homepage', { type: 'nuclear' });
        this.destroyInstance();
      }
    }).catch((err) => {
      //添加监控，记录日志
    });
  })
}

/**
 * 通过Horn控制轮询间隔
 * @returns 轮询间隔时长，单位ms
 */
export function getHornConfig(): number {
  const Horn = Mach.requireModule('SLCHorn');
  const config = Horn?.getAppConfig?.();
  const NuclearPollingInterval = config?.NuclearPollingInterval || 60;
  return NuclearPollingInterval * 1000;
}

export default PollingManager;
